`
<template>
  <RevIllustration
    alt="BCorp Logo"
    class="h-[76px] w-[46px]"
    :height="76"
    src="/img/b-corp/B-Corp-Logo-Black.svg"
    :width="46"
  />
</template>

<script setup>
import { RevIllustration } from '@ds/components/Illustration'
</script>
